import { css } from 'styled-components';

/**
 * Glassmorphism style mixins for consistent glass-like UI elements
 * These can be imported and used with the css helper from styled-components
 */

// Base glass style with subtle blur effect
export const glassBase = css`
  background: rgba(15, 23, 42, 0.25);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(99, 102, 241, 0.15);
`;

// Medium depth glass effect with stronger blur
export const glassMedium = css`
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(99, 102, 241, 0.2);
`;

// Deep glass effect with heavy blur for modals and important UI
export const glassDeep = css`
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(99, 102, 241, 0.3);
`;

// Glass effect with primary color tint
export const glassPrimary = css`
  background: rgba(63, 81, 181, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(99, 102, 241, 0.25);
`;

// Glass effect with success color tint
export const glassSuccess = css`
  background: rgba(16, 185, 129, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(16, 185, 129, 0.25);
`;

// Glass effect with warning color tint
export const glassWarning = css`
  background: rgba(245, 158, 11, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(245, 158, 11, 0.25);
`;

// Glass effect with error color tint
export const glassError = css`
  background: rgba(239, 68, 68, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(239, 68, 68, 0.25);
`;

// Hover effect for glass elements
export const glassHover = css`
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    border-color: rgba(99, 102, 241, 0.4);
  }
`;
